import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";

const rules = {
    address: {
        street: 'required',
        city: 'required',
        zipCode: 'required',
    }
};

export const allFieldsValidation = (data) => {
    return allFieldsValidationCommon(data, rules, customErrorMessagesCommon);
};